import { icon } from "../icons.js";
import {
  humanShort,
  adultsWord,
  childrenWord,
  fmtDateRange,
  diffNights,
  nightsWord,
} from "../lib/dates.js";
import { priceNote, fromNights } from "../lib/price-note.js";
import { esc } from "./html.js";

export function guestsSummary({ adults, children }) {
  let s = `${adults} ${adultsWord(adults)}`;
  if (children > 0) s += ` · ${children} ${childrenWord(children)}`;
  return s;
}

// Поисковая строка: «Заезд — выезд» · «Гости» · «Найти номер». Вид — по мини-модулю W2 (T25),
// с T26 общий для полного модуля и мини: над значениями подписи, выбранные даты —
// «12–15 сентября · 3 ночи», «Найти номер» без дат не выключена — клик откроет календарь
// (index.js); disabled держит только «Ищем…»
export function renderSearch(state) {
  const { checkin, checkout } = state.dates;
  const nights = checkin && checkout ? diffNights(checkin, checkout) : 0;
  const datesText =
    checkin && checkout
      ? `${fmtDateRange(checkin, checkout)} · ${nights} ${nightsWord(nights)}`
      : checkin
        ? `${humanShort(checkin)} — выезд?`
        : "Выберите даты";
  // finding: true — ждём quote, "retry" — повтор после таймаута/обрыва (T24); оба держат кнопку
  const finding = Boolean(state.ui.finding);
  const label =
    state.ui.finding === "retry" ? "Пробуем ещё раз…" : finding ? "Ищем…" : "Найти номер";
  const field = (cap, text, placeholder) =>
    `<span class="okb-sfield"><span class="okb-scap">${cap}</span><span class="okb-sval${placeholder ? " okb-placeholder" : ""}">${text}</span></span>`;
  return `
  <div class="okb-search">
    <button type="button" class="okb-chipbtn" data-okb="open-dates">
      ${icon("calendar")}${field("Заезд — выезд", datesText, !checkin)}<span class="okb-chevron">${icon("chevron")}</span>
    </button>
    <button type="button" class="okb-chipbtn" data-okb="open-guests">
      ${icon("guest")}${field("Гости", guestsSummary(state.guests), false)}<span class="okb-chevron">${icon("chevron")}</span>
    </button>
    <button type="button" class="okb-findbtn${finding ? " okb-busy" : ""}" data-okb="find" ${finding ? "disabled" : ""}>${label}</button>
  </div>`;
}

// Вступление над поиском (T15) — как блок «ПОИСК / НОМЕРОВ» на странице родного модуля сайта:
// заголовок из config/widget.json (introTitle; пусто — без заголовка), абзац «что делать» и как
// читать цены в календаре, красная строка про минимальный заезд. Числа ночей — из /api/config.
export function renderIntro(state) {
  const n = priceNote(state.config);
  if (!n) return "";
  const title = state.config?.widget?.introTitle;
  const titleHtml =
    Array.isArray(title) && title.length
      ? `<h2 class="okb-intro-title">${title
          .map((line, i) => `<span class="okb-intro-t${i + 1}">${esc(line)}</span>`)
          .join("")}</h2>`
      : "";
  const priceLine = n.detail
    ? `В календаре указана <b>минимальная цена за ночь ${esc(n.detail)}</b>.`
    : `В календаре указана <b>минимальная цена за ночь</b>.`;
  return `
  ${titleHtml}
  <p class="okb-intro-lead">Выберите даты и количество гостей — модуль покажет доступные номера
  и их стоимость. ${priceLine}</p>
  <p class="okb-intro-min">Бронирование доступно ${esc(fromNights(n.minStay))}.</p>`;
}
